import { styled, css } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";

export const Wrapper = styled.div<{ $columns: 1 | 2; $largerImage?: boolean }>`
  ${(props) =>
    props.$columns === 2 &&
    css`
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: ${(props) => props.theme.spacing.m};

      img {
        aspect-ratio: 2 / 1;
        width: 100% !important;
        height: auto;
        object-fit: cover;
        border-radius: ${(props) => props.theme.borderRadius};
      }

      @media (min-width: ${mobileBreakPointCSS}) {
        grid-template-columns: 1fr 1fr;
        img {
          height: 335px;
        }
      }

      ${props.$largerImage &&
      css`
        img {
          aspect-ratio: 1 / 1;
          max-height: 640px;
        }
        @media (min-width: ${mobileBreakPointCSS}) {
          img {
            aspect-ratio: auto;
            height: 640px;
          }
        }
      `}
    `}
`;

export const Figure = styled.figure<{
  $captionPosition: "left" | "right";
  $largerCaption?: boolean;
  $largeImage?: boolean;
  $noRoundCorners?: boolean;
}>`
  margin: 0;

  img {
    display: block;
    border-radius: ${(props) => props.theme.borderRadius};
    width: 100%;

    @media (min-width: ${mobileBreakPointCSS}) {
      width: 600px;
    }
  }

  figcaption {
    margin-top: ${(props) => props.theme.spacing.xs};
    font-style: italic;
  }

  ${(props) =>
    (props.$captionPosition === "right" || props.$largerCaption) &&
    css`
      figcaption {
        text-align: right;
      }
    `}

  ${(props) =>
    props.$largeImage &&
    css`
      img {
        width: 100%;
      }
    `};

  ${(props) =>
    props.$largerCaption &&
    css`
      figcaption {
        text-align: left;
        margin-top: ${(props) => props.theme.spacing.m};
      }

      @media (min-width: ${mobileBreakPointCSS}) {
        display: flex;
        align-items: center;

        figcaption {
          margin: 0;
          padding: 0 ${(props) => props.theme.spacing.l};
        }
      }
    `}

  ${(props) =>
    props.$noRoundCorners &&
    css`
      img {
        border-radius: 0;
      }
    `}
`;
